import script from "./FormFileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFileUpload.vue?vue&type=script&setup=true&lang=js"

import "./FormFileUpload.vue?vue&type=style&index=0&id=5f8c1210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8c1210"]])

export default __exports__